<script setup lang="ts">
import PopOver from './PopOver.vue';

type PopOverPropsType = InstanceType<typeof PopOver>['$props'];

type ConditionalPopOverProps = {
  enabled: boolean;
  popOverConfig: PopOverPropsType;
};

const props = defineProps<ConditionalPopOverProps>();
</script>

<template>
  <PopOver v-if="props.enabled" v-bind="props.popOverConfig">
    <slot />

    <template #content>
      <slot name="content" />
    </template>
  </PopOver>

  <slot v-else />
</template>
